/* BOU v5: comportamiento de las piezas propias.
 * - Compra en un solo paso (blocks/g-selector.liquid). Actualiza:
 *   - el precio grande, el %, las cuotas y el precio del botón;
 *   - los botones de color (se ocultan si la opción no tiene colores);
 *   - el aviso de envío gratis.
 *   Agregar al carrito lo hace <bou-selector> de assets/bou.js.
 * - Carrito lateral:
 *   - mejora de pack con un toque (1 o 2 packs → 3 packs; Magnéticas → Kit de inicio), de window.BOU.mejoras;
 *   - una línea de confianza debajo de «Pagar».
 * - Despacho: «Comprá en las próximas 2 h 15 min y lo despachamos hoy» (corte a las 14, de lunes a viernes).
 * - ?pack=N en la dirección de la ficha: llega con esa opción elegida.
 * - Pestañas de la ficha y botón «10% OFF» (solo en la computadora) que abre el popup de bienvenida.
 */
(() => {
  const CFG = window.BOU || {};
  const fmt = (c) => '$' + Math.round(c / 100).toLocaleString('es-AR');

  // ---------- Compra en un solo paso ----------
  document.querySelectorAll('[data-g-sel]').forEach((sel) => {
    const umbral = Number(sel.dataset.umbral || 5000000);
    const cuotas = Number(sel.dataset.cuotas || 3);
    const q = (s) => sel.querySelector(s);
    const ops = [...sel.querySelectorAll('.bou-sel__op')];
    const agr = q('[data-bou-agregado]');
    const colorWrap = q('[data-g-color-wrap]');
    let color = q('.g5__chip.is-on')?.dataset.gColor || null;

    const copiarColor = () => {
      if (!color) return;
      ops.forEach((op) => {
        const s = op.querySelector('select.bou-sel__variante');
        if (!s) return;
        const opt = [...s.options].find((o) => o.dataset.titulo === color && !o.disabled) || [...s.options].find((o) => !o.disabled);
        if (opt) s.value = opt.value;
      });
    };
    const pintar = () => {
      const op = ops.find((o) => o.querySelector('input[type=radio]')?.checked);
      if (!op) return;
      ops.forEach((o) => o.classList.toggle('is-sel', o === op));
      const precio = Number(op.dataset.precio), antes = Number(op.dataset.antes), pct = Number(op.dataset.pct || 0);
      const extra = agr && agr.checked ? Number(agr.dataset.precio || 0) : 0;
      q('[data-g-precio]').textContent = fmt(precio);
      q('[data-g-antes]').textContent = antes > precio ? fmt(antes) : '';
      const off = q('[data-g-off]');
      off.hidden = !(pct > 0);
      if (pct > 0) off.textContent = `-${pct}%`;
      q('[data-g-cuota]').textContent = fmt(precio / cuotas);
      q('[data-g-btn-precio]').textContent = fmt(precio + extra);
      if (colorWrap) colorWrap.hidden = Number(op.dataset.variantes || 1) < 2;
      // Envío gratis: cuánto falta y con qué opción se llega.
      const total = precio + extra;
      const env = q('[data-g-envio]');
      if (total >= umbral) env.innerHTML = '✓ <b>Tenés envío gratis a sucursal.</b>';
      else {
        const llega = ops.find((o) => Number(o.dataset.precio) >= umbral && !o.querySelector('input')?.disabled);
        const conAgr = agr && !agr.checked && precio + Number(agr.dataset.precio || 0) >= umbral;
        let t = `Te faltan <b>${fmt(umbral - total)}</b> para el envío gratis a sucursal.`;
        if (conAgr) t += ' Sumando la Cinta ya llegás.';
        else if (llega) t += ` Con <b>${llega.querySelector('.g5__nombre')?.textContent.trim()}</b> lo tenés.`;
        env.innerHTML = t;
      }
    };
    sel.querySelectorAll('[data-g-color]').forEach((b) => b.addEventListener('click', () => {
      color = b.dataset.gColor;
      sel.querySelectorAll('[data-g-color]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      const n = q('[data-g-color-nombre]'); if (n) n.textContent = color;
      copiarColor();
    }));
    sel.addEventListener('change', pintar);
    // ?pack=3 en la dirección: llega con esa opción elegida (la escalera de la portada lleva a la ficha así).
    const pack = Number(new URLSearchParams(location.search).get('pack'));
    if (pack > 0 && ops[pack - 1]) { const r = ops[pack - 1].querySelector('input[type=radio]'); if (r && !r.disabled) r.checked = true; }
    copiarColor();
    pintar();
  });

  // ---------- Despacho: si sale hoy, cuánto falta para el corte ----------
  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  function despacho(el) {
    const dias = (el.dataset.dias || '1,2,3,4,5').split(',').map(Number);
    const corte = Number(el.dataset.corte || 14) * 60;
    const ahora = new Date(Date.now() - 3 * 3600 * 1000);            // hora de Buenos Aires (UTC-3)
    const min = ahora.getUTCHours() * 60 + ahora.getUTCMinutes();
    const t = el.querySelector('[data-g5-despacho-txt]');
    if (!t) return;
    if (dias.includes(ahora.getUTCDay()) && min < corte) {
      const falta = corte - min, h = Math.floor(falta / 60), m = falta % 60;
      t.innerHTML = `Comprá en las próximas <b>${h ? h + ' h ' : ''}${m} min</b> y lo despachamos <b>hoy</b>.`;
      return;
    }
    let d;
    for (let i = 1; i < 8; i++) { d = new Date(ahora.getTime() + i * 86400000); if (dias.includes(d.getUTCDay())) break; }
    const dd = String(d.getUTCDate()).padStart(2, '0'), mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const manana = (d.getUTCDay() - ahora.getUTCDay() + 7) % 7 === 1;
    t.innerHTML = `Comprá hoy y lo despachamos <b>${manana ? 'mañana' : 'el ' + DIAS[d.getUTCDay()]} ${dd}/${mm}</b>.`;
  }
  document.querySelectorAll('[data-g5-despacho]').forEach((el) => { despacho(el); setInterval(() => despacho(el), 60000); });

  // ---------- Pestañas ----------
  document.querySelectorAll('[data-g-tabs]').forEach((t) => {
    const botones = [...t.querySelectorAll('[role=tab]')];
    botones.forEach((b) => b.addEventListener('click', () => {
      botones.forEach((x) => {
        const on = x === b;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        const panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }));
  });

  // ---------- Carrito lateral: mejora de pack y confianza ----------
  const MEJORAS = CFG.mejoras || [];
  let carrito = CFG.carrito || null;
  const secciones = () => [...new Set([...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean))];
  function htmlMejora(cart) {
    if (!cart || !cart.items) return '';
    const handles = cart.items.map((i) => i.handle);
    for (const m of MEJORAS) {
      const item = cart.items.find((i) => i.handle === m.desde && i.quantity === 1);
      if (!item || handles.includes(m.a.handle)) continue;
      if (m.siColor && item.variant_title !== m.siColor) continue;
      const dif = m.a.precio - item.final_line_price;
      if (dif <= 0) continue;
      return `<div class="g5-mejora" data-g5-mejora data-key="${item.key}" data-desde="${m.desde}"><img src="${m.a.imagen}" alt="" loading="lazy"><div><strong>${m.titulo}</strong><br>${m.texto} · por <strong>${fmt(dif)}</strong> más</div><button type="button" data-g5-cambiar>Cambiar</button></div>`;
    }
    return '';
  }
  function pintarCarrito() {
    document.querySelectorAll('.cart-drawer__summary, .cart-summary').forEach((dest) => {
      if (dest.parentElement?.closest('.cart-drawer__summary, .cart-summary')) return;
      dest.querySelectorAll('[data-g5-mejora]').forEach((n) => n.remove());
      const h = htmlMejora(carrito);
      if (h && carrito.item_count) dest.insertAdjacentHTML('afterbegin', h);
    });
    document.querySelectorAll('[name="checkout"]').forEach((b) => {
      const cont = b.parentElement;
      if (cont && !cont.querySelector('[data-g5-pago]')) b.insertAdjacentHTML('afterend', '<p class="g5-pago" data-g5-pago>Pago seguro con Mercado Pago · 3 cuotas sin interés</p>');
    });
  }
  async function refrescar() { try { carrito = await fetch('/cart.js').then((r) => r.json()); pintarCarrito(); } catch (_) {} }
  document.addEventListener('cart:update', () => setTimeout(refrescar, 450));
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-g5-cambiar]');
    if (!b) return;
    const caja = b.closest('[data-g5-mejora]');
    const m = MEJORAS.find((x) => x.desde === caja.dataset.desde);
    const item = carrito?.items.find((i) => i.key === caja.dataset.key);
    if (!m || !item) return;
    b.disabled = true; b.textContent = '…';
    try {
      // Mismo color si el pack nuevo lo tiene; si no, la primera versión con stock.
      const v = m.a.variantes.find((x) => x.titulo === item.variant_title && x.disponible) || m.a.variantes.find((x) => x.disponible);
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) });
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: secciones().join(','), sections_url: location.pathname }) });
      const data = await r.json();
      carrito = await fetch('/cart.js').then((x) => x.json());
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: carrito, sourceId: 'g5-mejora', data: { itemCount: carrito.item_count, source: 'g5-mejora', sections: data.sections } } }));
      pintarCarrito();
    } catch (_) { b.disabled = false; b.textContent = 'Cambiar'; }
  });
  // El tema redibuja el carrito: si se borra la mejora o la línea de pago, se vuelven a poner.
  let espera;
  new MutationObserver(() => { clearTimeout(espera); espera = setTimeout(() => {
    const falta = document.querySelector('[name="checkout"]') && !document.querySelector('[data-g5-pago]');
    const faltaMejora = htmlMejora(carrito) && !document.querySelector('[data-g5-mejora]');
    if (falta || faltaMejora) pintarCarrito();
  }, 120); }).observe(document.body, { childList: true, subtree: true });
  if (carrito) pintarCarrito(); else refrescar();

  // ---------- Botón «10% OFF» (en el celular el popup aparece solo) ----------
  const pop = document.querySelector('[data-bou-pop]');
  if (pop && !/\/(cart|checkout|account)/.test(location.pathname) && !document.querySelector('.product-information')) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'g-diez'; b.textContent = '10% OFF';
    b.addEventListener('click', () => { if (pop.dataset.paso !== 'codigo') pop.dataset.paso = 'raspar'; pop.classList.add('is-open'); });
    document.body.appendChild(b);
  }
})();
